var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-164 42.3 512 512",
    style: {
      enableBackground: "new -164 42.3 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2990D8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92,138.3c-114.9,0-208,93.1-208,208s93.1,208,208,208s208-93.1,208-208S206.9,138.3,92,138.3z M92,522.3 c-97.1,0-176-79-176-176c0-97.1,78.9-176,176-176c97,0,176,78.9,176,176C268,443.3,189,522.3,92,522.3z M-63.7,140.6 c-4.4-7.7-1.8-17.4,5.8-21.9l27.8-16c7.6-4.4,17.4-1.8,21.8,5.9l17.2,29.8c-20.1,8.1-38.6,18.9-55.4,32.1L-63.7,140.6z  M230.4,170.5c-16.7-13.2-35.3-24.1-55.4-32.1l17.2-29.8c4.4-7.7,14.2-10.3,21.9-5.9l27.7,16c7.7,4.4,10.3,14.2,5.9,21.9 L230.4,170.5z M44,90.3v-32c0-8.8,7.2-16,16-16h64c8.8,0,16,7.2,16,16v32c0,8.8-7.2,16-16,16v18.6c-10.5-1.5-21.1-2.6-32-2.6 s-21.5,1.1-32,2.6v-18.6C51.2,106.3,44,99.1,44,90.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92,387.7c-11,0-20-9-20-20V228.9c0-11,9-20,20-20s20,9,20,20v138.8C112,378.7,103,387.7,92,387.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 92,
    cy: 359.6,
    r: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.864669a5b684a2a56064a5fb48dbb5c3.svg";
export { ForwardRef as ReactComponent };